import { useTransition } from "remix"
import { MainMenu } from "./menus";


function Spinner() {
    return <span className={"Spinner-Ripple"}>
      <b/>
      <b/>
      <label>Loading...</label>
    </span>
  }

export function Header() {
    const transition = useTransition();

    console.log("Transition", transition)

    return (
        <header className="flex flex-row gap-2 justify-between">
        <div className=""><MainMenu /></div>
        <div className="">R&amp;H MOBILE</div>
        <div className="w-24 overflow-hidden px-2">{transition.state !== 'idle' ? <Spinner /> : ""}</div>
      </header>
    )
}